// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Or-z","badgeLink":"Pr-z","category":"Qr-z"};